import React from "react";
import MedictaApp from "./components/MedictaApp";
import Footer from "./components/Footer";
import ConsentBanner from "./components/ConsentBanner";
import { ThemeProvider } from "@mui/material/styles";
import { Theme } from "./Theme";
import { Box } from "@mui/material";
import { LangProvider } from "./context/LangContext";

/*const theme = createTheme({
  palette: {
    primary: {
      main: "#00ff00",
    },
  },
});*/

function App() {
  return (
    <LangProvider>
      <ThemeProvider theme={Theme}>
        <Box
          display="flex"
          flexDirection="column"
          minHeight="100vh"
          sx={{
            width: "100vw", // Empêche le débordement horizontal
            maxWidth: "100vw", // Limite la largeur à l'écran
            boxSizing: "border-box",
            overflowX: "hidden", // Supprime le scroll horizontal
            margin: 0,
            padding: 0,
          }}
        >
          <Box flexGrow={1}>
            <MedictaApp />
          </Box>
          <ConsentBanner />
          <Footer />
        </Box>
      </ThemeProvider>
    </LangProvider>
  );
}

export default App;
